import cookie from 'js-cookie';
import getCookiesOption from '@pro/common/utils/getCookiesOption';
import { deleteDBAll } from '@pro/common/dao/indexedDB';
import storage from '@pro/common/dao/storage';

/**
 * 清除浏览器本地缓存的用户登录信息
 *
 * 如果清除数据后会跳转到落地页，则无需清除store
 */
export function clearLocalLoginState() {
  storage.clear();
  // 删除手动升级存储的indexedDB数据
  deleteDBAll('MANUAL_UPDATE');
  const option = getCookiesOption();
  cookie.remove(storage.NAME.USER + 'login', option);
  cookie.remove('isAuthed', option);
  cookie.remove('emphasisStatus', option);
  cookie.remove('name', option);
  cookie.remove('avatar', option);
  cookie.remove('phone', option);
  cookie.remove('email', option);
  cookie.remove('country', option);
  sessionStorage.setItem('showNotice', 'true');
  // Web控件更新不再提醒标记
  sessionStorage.removeItem('WebControlUpdateTip');
  sessionStorage.removeItem('WebControlDllUpdateTip');
  sessionStorage.removeItem('ComponentUpdateTip');
}

export default clearLocalLoginState;
